import React from "react"
import {connect} from "react-redux"
import {Redirect} from 'react-router'

import moment from 'moment'

class Home extends React.Component {
  render() {
    if(this.props.user.user.preference === "w"){
      return <Redirect to={`/week/${moment().format('YYYYMMDD')}`}/>
    }else{
      return <Redirect to={`/month/${moment().format('YYYYMMDD')}`}/>
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)



// WEBPACK FOOTER //
// ./src/js/components/pages/Home.js